<template>
  <v-navigation-drawer app class="sidebar__main" v-model="drawer">
    <section class="sidebar__header">
      <img :src="require(`@/assets/svg/sra.svg`)" width="38px" alt="" />
      <small>{{ $t("system_name") }}</small>
    </section>

    <section class="card__menu" width="300">
      <section class="menu__list">
        <section class="mr-1" v-for="(item, index) in menuGroup" :key="index">
          <router-link
            v-if="!item.routes"
            class="list__item"
            active-class="list__item-active"
            :to="item.path"
          >
            <v-icon size="18" class="icon">{{ item.icon }}</v-icon>
            <span>{{ item.name }}</span>
          </router-link>

          <v-list-group v-else>
            <template v-slot:activator>
              <div class="group__list">
                <v-icon size="18" class="icon">{{ item.icon }}</v-icon>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </div>
            </template>

            <section class="group__item">
              <section v-for="(subMenu, index) in item.routes" :key="index">
                <router-link
                  class="list__item"
                  active-class="list__item-active"
                  :to="subMenu.path"
                >
                  <span class="max__width__text">{{ subMenu.name }}</span>
                </router-link>
              </section>
            </section>
          </v-list-group>
        </section>
      </section>

      <section class="version">
        <small>
          {{ version }}
        </small>
      </section>
    </section>
  </v-navigation-drawer>
</template>

<script>
import packageJson from "@/../package.json";
import { routesExceptions } from "@/router/index";
import { getConnectedUser } from "@/utils/localStorage";

export default {
  name: "TheSidebar",

  props: {
    resource: {
      type: Boolean,
    },
  },

  data: () => ({
    drawer: null,
    env: process.env.NODE_ENV,
  }),

  computed: {
    version() {
      return `Versão ${packageJson.version}`;
    },

    menuGroup() {
      let routes = [];
      let groups = [];

      this.$router.options.routes.forEach((element) => {
        if (element.groupBy !== undefined) {
          if (element.groupBy !== "") {
            groups.push(element.groupBy);
          }

          routes.push(element);
        }
      });

      const filterGroups = [...new Set(groups)];
      let formatedGroups = [];

      filterGroups.forEach((group) => {
        const groupRoutes = routes.filter((route) => route.groupBy === group);
        const sortedData = groupRoutes.sort((a, b) =>
          a.name.localeCompare(b.name, "pt-BR")
        );
        formatedGroups.push({ name: group, routes: sortedData });
      });

      const menuList = [
        { icon: "mdi-view-dashboard-outline", ...routes[0] },
        { icon: "mdi-table-large-plus", ...formatedGroups[0] },
        { icon: "mdi-file-document-plus-outline", ...routes[10] },
        { icon: "mdi-file-document-multiple-outline", ...routes[11] },
        { icon: "mdi-file-star-four-points-outline", ...routes[14] },
        { icon: "mdi-calendar-outline", ...routes[15] },
        { icon: "mdi-calendar-clock-outline", ...routes[16] },
        { icon: "mdi-calendar-check", ...formatedGroups[1] },
        { icon: "mdi-pulse", ...formatedGroups[2] },
        { icon: "mdi-scale-balance", ...routes[24] },
        { icon: "mdi-file-cog-outline", ...routes[20] },
        { icon: "mdi-message-question-outline", ...routes[19] },
      ];

      return this.checkPermissions(menuList);
    },
  },

  watch: {
    resource: function () {
      this.drawer = !this.drawer;
    },
  },

  methods: {
    checkPermissions(menuList) {
      const connectedUser = getConnectedUser();
      const exceptions = routesExceptions();
      const permissions = [...connectedUser.abilities, ...exceptions];

      menuList.forEach((itemList) => {
        if (!itemList.routes) {
          const check = permissions.includes(itemList.permission);

          if (!check) {
            menuList = menuList.filter((item) => item !== itemList);
          }

          return;
        }

        itemList.routes.forEach((subMenuListItem) => {
          const check = permissions.includes(subMenuListItem.permission);

          if (!check) {
            itemList.routes = itemList.routes.filter(
              (item) => item !== subMenuListItem
            );
          }
        });
      });

      menuList = menuList.filter((menuItem) => {
        if (menuItem.routes) {
          return menuItem.routes.length > 0;
        }

        return menuItem;
      });

      return menuList;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.sidebar__main {
  border: 1px solid #f1f1f1;
  background: #ffffff;
  height: 100%;

  .sidebar__header {
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 0;
    padding: 15px;
    min-height: 64px;
    background: #ffffff;

    small {
      line-height: 1.3;
      font-size: 12px;
      font-weight: 500;
    }
  }

  .card__menu {
    padding: 10px;
    background: #ffffff;

    .text__indicator {
      font-family: "Poppins", sans-serif;
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      margin-bottom: 15px;
    }

    .menu__list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-height: 700px;
      overflow-x: auto;

      .list__item {
        display: flex;
        align-items: center;
        gap: 5px;
        height: 45px;
        padding: 15px 10px;
        text-decoration: none;
        transition: 0.8s;

        .icon {
          color: $gray !important;
        }

        .max__width__text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 150px;
        }

        span {
          color: $gray;
          font-weight: 400;
          font-size: 13px;
        }
      }

      .list__item:hover {
        background: #f1f1f1 !important;
        border-radius: 10px;
        transition: 0.8s;
      }

      .list__item-active {
        background: #f3faff;
        border-radius: 10px;

        &:hover {
          background: #f3faff !important;
        }

        .icon {
          color: $blue !important;
        }

        span {
          color: $blue;
          font-weight: 600;
          font-size: 13px;
        }
      }
    }

    .group__list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      width: 100% !important;

      .icon {
        color: $gray !important;
      }

      .v-list-item__title {
        color: $gray;
        font-weight: 400;
        font-size: 13px;
      }
    }

    .group__item {
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin: 0 0 0 10px;
    }
  }

  .version {
    position: absolute;
    left: 0;
    bottom: 10px;
    text-align: center;
    color: $gray;
    font-size: 12px;
    width: 100%;
  }
}

.v-navigation-drawer__border {
  width: 0px !important;
}

.v-list-item {
  padding: 15px 10px !important;
  height: 45px !important;
  max-height: 45px !important;
  cursor: pointer;
  transition: 0.8s;
}

.v-list-item:hover {
  background: #f1f1f1 !important;
  border-radius: 10px;
  transition: 0.8s;
}

.theme--light.v-list-item--active:focus::before,
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before,
.theme--light.v-list-item:focus::before,
.theme--light.v-list-item:hover::before,
.theme--light.v-list-item:focus::before {
  opacity: 0 !important;
}

/* Mobile */
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%) !important;
  background: rgb(248, 248, 248) !important;
}
</style>
